import script from "./RfpDeadline.vue?vue&type=script&setup=true&lang=ts"
export * from "./RfpDeadline.vue?vue&type=script&setup=true&lang=ts"

import "./RfpDeadline.vue?vue&type=style&index=0&id=0acc9051&scoped=true&lang=css"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0acc9051"]])

export default __exports__